import { Popover } from '@headlessui/react'
import * as Checkbox from '@radix-ui/react-checkbox'
import { styled } from '@styles/theme'

export const subMatterArticleStyles = {
	Trigger: styled(Popover.Button, {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '14px 16px',
		width: '100%',
		minWidth: '200px',
		height: '50px',
		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',
		color: '$neutral160',
		fontWeight: '400',
		fontSize: '$lg',
		'&:hover': { borderColor: '$blue20', color: '$blue20' },
		'&:disabled': {
			borderColor: '$disabled',
			color: '$disabled',
			'&:hover': { borderColor: '$neutral50', color: '$neutral50' },
		},
		svg: { width: '24px', height: '24px' },
	}),

	Panel: styled(Popover.Panel, {
		zIndex: '100',
		position: 'absolute',
		right: 0,
		marginTop: '8px',
		width: '100%',
		'@md': { minWidth: '380px' },
		background: '$neutral10',
		outline: '1px solid $neutral50',
		borderRadius: '12px',
		color: '$neutral160',
	}),

	Group: styled('div', {
		borderBottom: '1px solid $neutral30',
		'&:last-child': { borderBottom: 'none' },
	}),

	Row: styled('div', {
		display: 'flex',
		alignItems: 'flex-start',
		gap: '12px',
		padding: '12px 12px 12px 16px',
		color: '$neutral150',
		fontSize: '$md',
		lineHeight: '20px',
		cursor: 'pointer',
		'&:hover': { background: '$neutral30', color: '$blue20' },
		variants: {
			active: { true: { color: '$blue20', fontWeight: '500' } },
		},
	}),

	Name: styled('span', { flex: 1, textAlign: 'left' }),

	Counter: styled('span', {
		marginLeft: '6px',
		color: '$neutral70',
		fontSize: '$sm',
		fontWeight: '400',
		whiteSpace: 'nowrap',
	}),

	Toggle: styled('button', {
		all: 'unset',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '24px',
		height: '24px',
		color: '$neutral70',
		cursor: 'pointer',
		svg: { width: '16px', height: '16px' },
	}),

	Articles: styled('div', { padding: '0 12px 8px 44px' }),

	Actions: styled('div', {
		display: 'flex',
		gap: '16px',
		padding: '4px 0 8px',
	}),

	Action: styled('button', {
		all: 'unset',
		color: '$blue20',
		fontSize: '$md',
		cursor: 'pointer',
		'&:hover': { textDecoration: 'underline' },
	}),

	ArticleRow: styled('div', {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		padding: '8px',
		borderRadius: '8px',
		fontSize: '$md',
		color: '$neutral150',
		cursor: 'pointer',
		userSelect: 'none',
		WebkitUserSelect: 'none',
		WebkitTouchCallout: 'none',
		'&:hover': { background: '$neutral30' },
		variants: {
			active: { true: { color: '$blue20', fontWeight: '500' } },
		},
	}),

	Box: styled(Checkbox.Root, {
		all: 'unset',
		flexShrink: 0,
		width: 20,
		height: 20,
		borderRadius: 3,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: '$neutral10',
		border: '1px solid $neutral80',
		'&[data-state="checked"], &[data-state="indeterminate"]': {
			background: '$blue20',
			borderColor: '$blue20',
			color: '$neutral10',
		},
	}),

	BoxIndicator: styled(Checkbox.Indicator, {
		display: 'flex',
		svg: { width: '14px', height: '14px' },
	}),

	Empty: styled('div', { padding: '10px', textAlign: 'center' }),
}
